/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Mode_ExtractInputs */



/**
* | output |
* | --- |
* | "Extract Captions" |
*
* @param {Drastic_Tech_Mode_ExtractInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_mode_extract = /** @type {((inputs?: Drastic_Tech_Mode_ExtractInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Mode_ExtractInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extraire les sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auszug aus den Bildunterschriften")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrai didascalie")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Извлечь подписи")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extraer subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提取字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションの抽出")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन निकालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas de trechos")
	return /** @type {LocalizedString} */ ("Extract Captions")
});